import React, { useState, useEffect } from 'react';
import '../styles/popupMenu.css';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import JsonData from '../data/data.json';

const PopupMenu = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const [PopUpData, setPopUpData] = useState([]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsVisible(true);
    }, 100000);

    return () => clearInterval(intervalId);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const firestore = firebase.firestore();
    const popupDataRef = firestore.collection("PopUpData");

    const unsubscribe = popupDataRef.onSnapshot(
      (snapshot) => {
        const newPopUpData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setPopUpData(newPopUpData);
      },
      (error) => {
        console.error("Firebase Error:", error);
      }
    );

    return () => unsubscribe();
  }, []);

  // Firebase data first, otherwise local JSON
  const popupImage =
    PopUpData.length > 0
      ? PopUpData[0]?.imageUrl
      : JsonData.PopUp?.[0]?.imageUrl;

  return (
    isVisible && (
      <div className="popupmenudiv">
        <button className="closeButton" onClick={handleClose}>
          &times;
        </button>

        {popupImage && (
          <img src={popupImage} alt="popupimage" />
        )}
      </div>
    )
  );
};

export default PopupMenu;